import { hasWindow, getWindow } from '@ztechapps/common.utils'

export type { WebTelemetryConfig } from '@ztechapps/common.contract'

/**
 * Default configuration values
 */
export const DEFAULT_CONFIG = {
  sampleRate: 1.0,
  debug: false,
  enabled: true,
  serviceVersion: '1.0.0',
} as const

/**
 * Session storage key for session ID
 */
export const SESSION_ID_KEY = 'otel_session_id'

/**
 * User storage key for user ID
 */
export const USER_ID_KEY = 'otel_user_id'

/**
 * Session timeout in milliseconds (30 minutes)
 */
export const SESSION_TIMEOUT_MS = 30 * 60 * 1000

/**
 * Metric and span name prefixes
 */
export const METRIC_PREFIX = 'frontend'
export const SPAN_PREFIX = 'frontend'

/**
 * Derive environment from hostname
 *
 * @example
 * - localhost:5001 → 'development'
 * - beta.panelpunches.com → 'beta'
 * - admin-beta.panelpunches.com → 'beta'
 * - v3.panelpunches.com → 'staging'
 * - panelpunches.com → 'production'
 */
export function deriveEnvironmentFromHostname(hostname?: string): string {
  const host = hostname || (hasWindow() ? getWindow().location.hostname : 'localhost')

  if (host === 'localhost' || host === '127.0.0.1') {
    return 'development'
  }

  if (host.includes('beta') || host.includes('-beta')) {
    return 'beta'
  }

  if (host.includes('v3') || host.includes('-v3') || host.includes('staging')) {
    return 'staging'
  }

  return 'production'
}
